import agendamentoExame from './agendamentoExameRepository'
import agendamentoExameRetroativo from './agendamentoExameRetroativoRepository'
import assinaturaEletronica from './assinaturaEletronicaRepository'
import cancelamentoResultado from './cancelamentoResultadoRepository'
import coletaAgendada from './coletaAgendadaRepository'
import entregaExame from './entregaExameRepository'
import exameAgendadoRealizado from './exameAgendadoRealizadoRepository'
import exameProducao from './exameProducaoRepository'
import exameSolicitadoStatus from './exameSolicitadoStatusRepository'
import formulaExame from './formulaExameRepository'
import importarLaudo from './importarLaudoRepository'
import impressaoExame from './impressaoExameRepository'
import impressoes from './impressoesRepository'
import jornada from './jornadaRepository'
import jornadaBloqueio from './jornadaBloqueioRepository'
import lancamentoColeta from './lancamentoColetaRepository'
import lancamentoResultado from './lancamentoResultadoRepository'
import mapaDia from './mapaDiaRepository'
import mapaProducao from './mapaProducaoRepository'
import parametrizacao from './parametrizacaoRepository'
import relatorioColetaRealizada from './relatorioColetaRealizadaRepository'
import relatorioCotaConsumo from './relatorioCotaConsumoRepository'
import relatorioExameBloqueado from './relatorioExameBloqueadoRepository'
import relatorioExameLaboratorioApoio from './relatorioExameLaboratorioApoioRepository'
import relatorioFinanceiroExame from './relatorioFinanceiroExameRepository'
import relatorioFinanceiroPaciente from './relatorioFinanceiroPacienteRepository'
import relatorioHistoricoPaciente from './relatorioHistoricoPacienteRepository'
import relatorioPacienteAtendido from '@/repositories/conecta-sus/exame-laboratorial/relatorioPacienteAtendidoRepository'
import relatorioQuantitativoExameSolicitado from './relatorioQuantitativoExameSolicitadoRepository'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducaoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/exame-laboratorial`

    return {
        agendamentoExame: agendamentoExame(baseUrl),
        agendamentoExameRetroativo: agendamentoExameRetroativo(baseUrl),
        assinaturaEletronica: assinaturaEletronica(baseUrl),
        cancelamentoResultado: cancelamentoResultado(baseUrl),
        coletaAgendada: coletaAgendada(baseUrl),
        entregaExame: entregaExame(baseUrl),
        exameAgendadoRealizado: exameAgendadoRealizado(baseUrl),
        exameProducao: exameProducao(baseUrl),
        exameSolicitadoStatus: exameSolicitadoStatus(baseUrl),
        formulaExame: formulaExame(baseUrl),
        importarLaudo: importarLaudo(baseUrl),
        impressaoExame: impressaoExame(baseUrl),
        impressoes: impressoes(baseUrl),
        jornada: jornada(baseUrl),
        jornadaBloqueio: jornadaBloqueio(baseUrl),
        lancamentoColeta: lancamentoColeta(baseUrl),
        lancamentoResultado: lancamentoResultado(baseUrl),
        mapaDia: mapaDia(baseUrl),
        mapaProducao: mapaProducao(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        relatorioColetaRealizada: relatorioColetaRealizada(baseUrl),
        relatorioCotaConsumo: relatorioCotaConsumo(baseUrl),
        relatorioExameBloqueado:relatorioExameBloqueado(baseUrl),
        relatorioExameLaboratorioApoio: relatorioExameLaboratorioApoio(baseUrl),
        relatorioFinanceiroExame: relatorioFinanceiroExame(baseUrl),
        relatorioFinanceiroPaciente: relatorioFinanceiroPaciente(baseUrl),
        relatorioHistoricoPaciente: relatorioHistoricoPaciente(baseUrl),
        relatorioPacienteAtendido: relatorioPacienteAtendido(baseUrl),
        relatorioQuantitativoExameSolicitado: relatorioQuantitativoExameSolicitado(baseUrl),
        relatorioQuantitativoProducao: relatorioQuantitativoProducao(baseUrl),
    }
}
